module.exports = __webpack_public_path__ + "img/collar_button_diameter.9fedd594.png";